module.exports = __webpack_public_path__ + "r-s2.png?3892da0a9044a904c89018e1640fc829";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/r-s2.png
// module id = 66
// module chunks = 0